import { type CSSObject } from '@emotion/react';

type Return = Record<'heading', CSSObject>;

export const useHeadingStyles = ({
  isVisuallyHidden,
}: {
  isVisuallyHidden?: boolean;
}): Return => {
  return {
    heading: {
      ...(isVisuallyHidden && {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px',
      }),
    },
  };
};
